import React from 'react'
import Element from './Element'

export default () => (
    <Element />
)
